export default "-- ClickBench Q7\nselect advengineid, count(*)\nfrom hits\nwhere advengineid <> 0\ngroup by advengineid\norder by count(*) desc;";